module.exports = __webpack_public_path__ + "img/52114120_L.d9d88457.png";